module.exports = __webpack_public_path__ + "static/media/10-15-4-Day-Overcast.8f5eeab8.jpg";